import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const SubmitButton = ({
  className: classNameProp,
  component: Component,
  ...other
}) => {
  const className = classNames(
    'submit-button',
    classNameProp
  )
  return (
    <>
      <Component className={className} {...other} />
      <style jsx>{`
      .submit-button {
        position: relative;
        display: inline-flex;
        font-weight: 400;
        white-space: nowrap;
        font-size: 14px;
        text-decoration: none;
        color: #fff;
        background-color: #0fc3c4;
        width: 30%;
        padding: .5rem 1rem;
        border-radius: 4px;
        text-align: center;
        justify-content: center;
      }
      `}
      </style>
    </>
  )
}

SubmitButton.propTypes = {
  className: PropTypes.string,
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
  ]),
}

SubmitButton.defaultProps = {
  component: 'button',
}

export default SubmitButton
